export default {
  colors: [
    {
      name: 'red',
      value: 'red'
    },
    {
      name: 'green',
      value: 'green'
    },
    {
      name: 'blue',
      value: 'blue'
    }
  ]
}
